module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14iqF49/tc-custom/9781524881856.jpg?1712142987388",
      "alt": "This image is the cover for the book Bingeworthy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bingeworthy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Featuring the award-winning combination of Jerry Scott's trademark humor and Jim Borgman's brilliant line art, "), _c('i', [_vm._v("Zits")]), _vm._v(" is the perfect comic for anyone parenting a teenager, or who remembers the days of sleeping in until noon, subsisting entirely on pizza, and rehearsing for an arena rock tour from the cozy confines of the garage. This fantastic "), _c('i', [_vm._v("Zits")]), _vm._v(" treasury presents the timeless teenage antics of Jeremy and friends and the trials of his Baby Boomer parents. Filled with lessons about growing up and growing older, this book contains so many laughs it will make your sides hurt. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jerry Scott, Jim Borgman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0